import styled from '@emotion/styled';

export const UploadPageContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
`;

export const PageHeader = styled.header`
  width: 100%;
  padding: 24px 32px;
  background: #ffffff;
  border-bottom: 1px solid #7C3AED;
  display: flex;
  flex-direction: column;
  gap: 20px;
  
  @media (max-width: 768px) {
    padding: 16px 20px;
  }
`;

export const HeaderTop = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
  
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const PageTitle = styled.h1`
  color: #333333;
  font-family: "Inter", sans-serif;
  font-size: 28px;
  line-height: 36px;
  font-weight: 700;
  margin: 0;
`;

export const PageSubtitle = styled.p`
  color: #666666;
  font-family: "Inter", sans-serif;
  font-size: 16px;
  line-height: 24px;
  font-weight: 400;
  margin: 4px 0 0 0;
`;

export const HeaderActions = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  
  @media (max-width: 768px) {
    width: 100%;
    justify-content: space-between;
  }
`;

export const RefreshButton = styled.button`
  padding: 8px 16px;
  background: #f3f4f6;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  color: #374151;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  gap: 8px;
  
  &:hover:not(:disabled) {
    background: #e5e7eb;
    border-color: #9ca3af;
  }
  
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const FileCount = styled.div`
  color: #6b7280;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  line-height: 20px;
  font-weight: 500;
  padding: 4px 12px;
  background: #f9fafb;
  border-radius: 20px;
  border: 1px solid #e5e7eb;
`;

export const FilterSection = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  align-items: center;
  
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
  }
`;

export const SearchBox = styled.div`
  position: relative;
  flex: 1;
  max-width: 300px;
  
  @media (max-width: 768px) {
    max-width: none;
  }
`;

export const SearchInput = styled.input`
  width: 100%;
  height: 40px;
  padding: 0 16px 0 44px;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  line-height: 20px;
  color: #374151;
  transition: border-color 0.2s ease;
  box-sizing: border-box;
  
  &:focus {
    outline: none;
    border-color: #6A42F2;
    box-shadow: 0 0 0 3px rgba(106, 66, 242, 0.1);
  }
  
  &::placeholder {
    color: #9ca3af;
  }
  
  &:disabled {
    background: #f9fafb;
    cursor: not-allowed;
    opacity: 0.6;
  }
`;

export const SearchIcon = styled.div`
  position: absolute;
  left: 16px;
  top: 50%;
  transform: translateY(-50%);
  color: #9ca3af;
  font-size: 16px;
  pointer-events: none;
`;

export const FilterButtons = styled.div`
  display: flex;
  gap: 8px;
  
  @media (max-width: 768px) {
    width: 100%;
    justify-content: space-between;
  }
`;

export const FilterButton = styled.button`
  padding: 8px 16px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  background: ${({ active }) => active ? '#6A42F2' : '#ffffff'};
  color: ${({ active }) => active ? '#ffffff' : '#374151'};
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
  
  &:hover:not(:disabled) {
    ${({ active }) => active 
      ? 'background: #5936e8;' 
      : 'background: #f9fafb; border-color: #9ca3af;'
    }
  }
  
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const SortButtons = styled.div`
  display: flex;
  gap: 8px;
  
  @media (max-width: 768px) {
    width: 100%;
    justify-content: space-between;
  }
`;

export const SortButton = styled.button`
  padding: 8px 12px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  background: ${({ active }) => active ? '#e0f2fe' : '#ffffff'};
  color: ${({ active }) => active ? '#0369a1' : '#374151'};
  font-family: "Inter", sans-serif;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
  
  &:hover:not(:disabled) {
    ${({ active }) => active 
      ? 'background: #bae6fd;' 
      : 'background: #f9fafb; border-color: #9ca3af;'
    }
  }
  
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const ContentArea = styled.main`
  flex: 1;
  position: relative;
  overflow: hidden;
`;

export const LoadingOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.9);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 100;
  gap: 16px;
`;

export const LoadingSpinner = styled.div`
  width: 40px;
  height: 40px;
  border: 4px solid #e5e7eb;
  border-top: 4px solid #6A42F2;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;

export const LoadingText = styled.div`
  color: #6A42F2;
  font-family: "Inter", sans-serif;
  font-size: 16px;
  line-height: 24px;
  font-weight: 500;
  text-align: center;
`;

export const ErrorMessage = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 32px 24px;
  background: #ffffff;
  border: 1px solid #fecaca;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  z-index: 100;
  max-width: 400px;
`;

export const ErrorIcon = styled.div`
  font-size: 48px;
  margin-bottom: 16px;
`;

export const ErrorText = styled.div`
  color: #dc2626;
  font-family: "Inter", sans-serif;
  font-size: 16px;
  line-height: 24px;
  font-weight: 500;
  margin-bottom: 20px;
`;

export const RetryButton = styled.button`
  padding: 8px 16px;
  background: #dc2626;
  border: none;
  border-radius: 6px;
  color: #ffffff;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.2s ease;
  
  &:hover {
    background: #b91c1c;
  }
`;

export const FileGridContainer = styled.div`
  width: 100%;
  height: 100%;
  padding: 32px;
  overflow-y: auto;
  overflow-x: hidden;
  box-sizing: border-box;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(400px, 500px));
  gap: 32px;
  justify-content: center;
  align-content: start;
  
  @media (max-width: 1200px) {
    grid-template-columns: 1fr;
    gap: 24px;
    padding: 24px 20px;
  }
`;

export const EmptyState = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 48px 24px;
`;

export const EmptyIcon = styled.div`
  font-size: 64px;
  margin-bottom: 24px;
  opacity: 0.6;
`;

export const EmptyTitle = styled.h2`
  color: #374151;
  font-family: "Inter", sans-serif;
  font-size: 24px;
  line-height: 32px;
  font-weight: 600;
  margin: 0 0 12px 0;
`;

export const EmptyDescription = styled.p`
  color: #6b7280;
  font-family: "Inter", sans-serif;
  font-size: 16px;
  line-height: 24px;
  font-weight: 400;
  margin: 0 0 32px 0;
  max-width: 400px;
`;

export const EmptyButton = styled.button`
  padding: 12px 24px;
  background: #6A42F2;
  border: none;
  border-radius: 8px;
  color: #ffffff;
  font-family: "Inter", sans-serif;
  font-size: 16px;
  line-height: 24px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  
  &:hover {
    background: #5936e8;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(106, 66, 242, 0.3);
  }
`;

export const Pagination = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  padding: 24px 32px;
  background: #ffffff;
  border-top: 1px solid #e5e7eb;
  
  @media (max-width: 768px) {
    padding: 16px 20px;
    gap: 12px;
  }
`;

export const PaginationButton = styled.button`
  padding: 8px 16px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  background: #ffffff;
  color: #374151;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  
  &:hover:not(:disabled) {
    background: #f9fafb;
    border-color: #9ca3af;
  }
  
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    background: #f9fafb;
  }
`;

export const PageNumbers = styled.div`
  display: flex;
  gap: 4px;
  
  @media (max-width: 768px) {
    gap: 2px;
  }
`;

export const PageNumber = styled.button`
  width: 36px;
  height: 36px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  background: ${({ active }) => active ? '#6A42F2' : '#ffffff'};
  color: ${({ active }) => active ? '#ffffff' : '#374151'};
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  
  &:hover:not(:disabled) {
    ${({ active }) => active 
      ? 'background: #5936e8;' 
      : 'background: #f9fafb; border-color: #9ca3af;'
    }
  }
`;

export const PageInfo = styled.div`
  color: #6b7280;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;
  white-space: nowrap;
  
  @media (max-width: 768px) {
    font-size: 12px;
  }
`;

export const HelpSection = styled.section`
  width: 100%;
  padding: 24px 32px;
  background: #f8f9fa;
  border-top: 1px solid #e5e7eb;
  
  @media (max-width: 768px) {
    padding: 16px 20px;
  }
`;

export const HelpTitle = styled.h3`
  color: #333333;
  font-family: "Inter", sans-serif;
  font-size: 18px;
  line-height: 28px;
  font-weight: 600;
  margin: 0 0 16px 0;
`;

export const HelpList = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 16px;
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 12px;
  }
`;

export const HelpItem = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 12px 16px;
  background: #ffffff;
  border-radius: 8px;
  border: 1px solid #e5e7eb;
  transition: all 0.2s ease;
  
  &:hover {
    border-color: #6A42F2;
    box-shadow: 0 2px 8px rgba(106, 66, 242, 0.1);
  }
`;

export const HelpIcon = styled.div`
  font-size: 20px;
  flex-shrink: 0;
  margin-top: 2px;
`;

export const HelpText = styled.div`
  color: #4b5563;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;
  
  strong {
    color: #1f2937;
    font-weight: 600;
  }
`;